<template>
  <span
    v-if="displayValue !== ''"
    :title="title"
    :class="{ 'filterable-cell': isFilterableCell }"
  >
    {{ displayValue }}
  </span>
</template>

<script>
export default {
  computed: {
    displayValue() {
      return this.params.valueFormatted ?? (this.params.value || '');
    },
    isFilterableCell() {
      const mapping =
        this.params.columnToFilterMapping[this.params?.colDef?.colId];
      const totalsRow = this.params?.node?.rowPinned === 'bottom';

      return (
        this.params.colDef.enableFilter ||
        (mapping &&
          !mapping.blockFilterForRoles?.includes(this.params.role) &&
          (!mapping.excludeTotalsRow ||
            (mapping.excludeTotalsRow && !totalsRow)))
      );
    },
    title() {
      return this.isFilterableCell
        ? `${this.displayValue} - Click to Filter`
        : this.vadisplayValuelue;
    },
  },
};
</script>
